import React from 'react';
import { Component } from '@poa/core';
import { getProfileIcon } from '../../icons/profile';

function getBecome(become) {
    if (typeof become === 'object' && become !== null) return JSON.stringify(become);
    else return become;
}


class AccountHistory extends React.Component {
    store; // injected by Poa
        
    HistoryItem({ history }) {
        return (
            <div className="account-history__item">
            <button className="account-history__refresh refresh-btn">
                <svg className="icon icon-refresh" />
            </button>
            <div className="account-history__head">
                <div className="account-history__title">{history.fullName}</div>
                <div className="account-history__date">{history.datetime}</div>
            </div>
            <div className="account-history__body">
                <table className="account-history__table">
                <thead>
                    <tr>
                    <th />
                    <th>Было</th>
                    <th>Стало</th>
                    </tr>
                </thead>
                <tbody>
                    {history.changes.map(change => (
                    <tr key={change.field}>
                        <td>{change.field}</td>
                        <td>{change.was}</td>
                        <td>{getBecome(change.become)}</td>
                    </tr>
                    ))}
                </tbody>
                </table>
            </div>
            </div>
        );
    }

    render() {

        const { originalModel } = this.store.accounts;

        return (
            <div className='general_info__content'>
                {
                    originalModel !== null ?
                        <>
                            {originalModel.history.map((history, index) => (
                                <this.HistoryItem key={index} history={history} />
                            ))}
                        </>
                        :
                        <div className='main-row'>
                            <div className='no-profile-found-text'>
                                {getProfileIcon('noUser')}
                                Профиль не найден
                            </div>
                        </div>
                }
            </div>
        );
    }
}

export default Component({ namespaces: ['account-history'] })(AccountHistory);